'use strict';

import defaultTemplate from '../../core/default.html';
import rulesEditTemplate from './rules.edit.html';

import Rules from './rules.ctrl';

function RulesRouter($urlRouterProvider, $stateProvider) {
  $stateProvider
    .state('main.rules', {
      url: '/rules',
      template: defaultTemplate
    })
    .state('main.rules.view', {
      url: '/view?:from&:userId&:locationId&:deviceId&:ruleId',
      template: rulesEditTemplate,
      controller: 'RulesEditController as vm'
    });
}

export default angular
  .module('rules.router', [
    Rules
  ])
  .config(RulesRouter)
  .name;
